<div class="header">
	<h3>
		{{ 'RESTREAMS' | translate }}
	</h3>
</div>

<span class="button new" [ngClass]="{disabled: haveUnsavedNewRestreams}" (click)="newRestream()" [hasPermission]="'live'">
	<i class="fa fa-plus"></i>{{ 'ADD_NEW_RESTREAM' | translate | uppercase }}
</span>

<bb-table-container>						
	<bb-table-header>
		<bb-table-header-cell property="title">{{ 'RESTREAM_TITLE' | translate }}</bb-table-header-cell>
		<bb-table-header-cell property="target-url">{{ 'TARGET_URL' | translate }}</bb-table-header-cell>
		<bb-table-header-cell property="status" class="icon">&nbsp;</bb-table-header-cell>
		<bb-table-header-cell class="buttons"></bb-table-header-cell>
	</bb-table-header>

	<bb-table-row *ngIf="restreams.length === 0">
		<bb-table-cell property="title" class="overflow"><span>{{ 'NO_RESULTS_FOUND' | translate }}</span></bb-table-cell>
		<bb-table-cell property="target-url">&nbsp;</bb-table-cell>
		<bb-table-cell property="status">&nbsp;</bb-table-cell>
		<bb-table-cell></bb-table-cell>
	</bb-table-row>

	<bb-table-row *ngFor="let row of restreams;let i = index;" [row]="row">
		<bb-table-cell property="title" class="overflow"><span>{{ row?.title || row?.id }}</span></bb-table-cell>
		<bb-table-cell property="target-url" *ngIf="row && row['public-url']"><span><a href="{{ row['public-url'] }}" target="_BLANK">{{ row['public-url'] }}</a></span></bb-table-cell>
		<bb-table-cell property="target-url" *ngIf="!(row && row['public-url'])"><span></span></bb-table-cell>
		<bb-table-cell property="status"><span><i [ngClass]="{'green': row?.state === 'enabled', 'red': row?.state !== 'enabled'}" class="fa fa-circle"></i></span></bb-table-cell>
		<bb-table-cell class="buttons">

			<a class="button" [class.disabled]="row?.id === 'new' || !(row && row['public-url'])" (click)="openPublicUrl(row)">
					<i class="fa fa-eye"></i>
			</a><!--

			--><a class="button" [class.disabled]="row?.id === 'new'" [class.active]="row?.quickEditing" (click)="row.quickEditing = !row.quickEditing">
				<i class="fa fa-pencil"></i>
			</a>
			
		</bb-table-cell>
		<div quickedit>
			<restream-quickedit [row]="row" [streamUuid]="streamUuid" *ngIf="row?.quickEditing" (saved)="onItemSaved()" (canceled)="onItemRemoved(restreams, i)" (removed)="onItemRemoved(restreams, i)">
			</restream-quickedit>
		</div>
	</bb-table-row>

</bb-table-container>

<bb-table-pager></bb-table-pager>
